import React, { useEffect, useState } from "react";
import {
  FormControl,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const NewHeader = () => {
  const [data, setData] = useState([]);
  const [countData, setCountData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(null);
  const [rowData, setRowData] = useState({});
  const storeId = localStorage.getItem("store_id");
  const [searchQuery, setSearchQuery] = useState("");
  // Add category Name start
  const [options, setOptions] = useState("category");
  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");
  const [brandId, setBrandId] = useState("");

  const [title, setTitle] = useState("");
  const [image, setImage] = useState("");
  const [url, setUrl] = useState("");
  const [ordering, setOrdering] = useState("");
  const [ids, setIds] = useState(null);

  const [mainData, setMainData] = useState([]);
  const [mainHeaderID, setMainHeaderID] = useState("");

  const mainHeaderDataList = () => {
    axios
      .get(`https://storebh.bhaaraterp.com/api/admin/main-customization-header/`, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        console.log("header===>", response?.data);
        setMainData(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    mainHeaderDataList();
  }, []);

  const headerData = () => {
    axios
      .get(
        `https://storebh.bhaaraterp.com/api/admin/customization-header/?search=${searchQuery}&page=${page}`,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setData(response?.data?.data);
        setCountData(response?.data?.count);
        setCurrentPage(response.data.current_page);
        setTotalPage(response.data.total_pages);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    headerData();
  }, [searchQuery, page]);

  const submitCategory = () => {
    const fd = new FormData();
    fd.append("title", title);
    fd.append("url", url);
    fd.append("ordering", ordering);
    fd.append("image", image);
    fd.append(
      "main_category_id",
      categoryId || rowData?.main_category?.id || ""
    );
    fd.append("subcategory_id", subCategoryId | rowData?.subcategory?.id || "");
    fd.append("brand_id", brandId || rowData?.brand?.id || "");

    ids === null
      ? axios
          .post(
            `https://storebh.bhaaraterp.com/api/admin/customization-header/?main_customization_header_id=${mainHeaderID}`,
            fd,
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            }
          )
          .then((response) => {
            toast.success(response.data.message);
            setTitle("");
            setIds(null);
            setUrl("");
            setOrdering("");
            setMainHeaderID("");
            setRowData({});
            handleClose();
            headerData();
          })
          .catch((error) => {
            console.log("error page", error.response);
            console.log(error);
          })
      : // Edit functionality to business category
        axios
          .put(
            `https://storebh.bhaaraterp.com/api/admin/customization-header/?store_id=${storeId}&main_customization_header_id=${rowData?.main_customization_header?.id}&customization_header_id=${ids}`,
            fd,
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            }
          )
          .then((response) => {
            toast.success(response.data.message);
            setTitle("");
            setIds(null);
            setUrl("");
            setMainHeaderID("");
            setOrdering("");
            setRowData({});
            handleClose();
            headerData();
          })
          .catch((error) => {
            console.log("error page", error.response);
            console.log(error);
          });
  };

  const previousData = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };
  const nextData = () => {
    if (page < totalPage) {
      setPage(page + 1);
    }
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const EditFunction = (row) => {
    console.log(row);
    setRowData(row);
    setIds(row?.id);
    setTitle(row?.title);
    setUrl(row?.url);
    setOrdering(row?.ordering);
  };

  const hangleCancel = () => {
    setTitle("");
    setIds(null);
    setUrl("");
    setOrdering("");
    setMainHeaderID("");
    setSubCategoryId("");
    setCategoryId("");
    setBrandId("");
    handleClose();
    headerData();
  };

  const categoryList = () => {
    axios
      .post(
        `https://storebh.bhaaraterp.com/api/multivendor-show-main-category-list-admin/`,
        {},
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setCategoryData(response?.data?.main_category_data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    categoryList();
  }, []);

  const subCategoryList = () => {
    axios
      .post(
        `https://storebh.bhaaraterp.com/api/multivendor-show-sub-category-list/`,
        {},
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setSubCategoryData(response?.data?.sub_cat_list);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    subCategoryList();
  }, []);

  const brandList = () => {
    axios
      .post(
        `https://storebh.bhaaraterp.com/api/multivendor-show-brand-list/`,
        {search_values:""},
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setBrandData(response?.data?.brand_list_serializer);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    brandList();
  }, []);





  // const mainCategoryList = () => {
  //   axios
  //     .post(
  //       `https://storebh.bhaaraterp.com/api/multivendor-show-main-category-list-admin/`,{},
  //       {
  //         headers: {
  //           Token: localStorage.getItem("Token"),
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       // console.log("category Data List===>", response?.data?.main_category_data);
  //       setCategoryData(response?.data?.main_category_data);
  //     })
  //     .catch((error) => {
  //       console.log("", error);
  //     });
  // };
  // useEffect(() => {
  //   mainCategoryList();
  // }, []);

  // const subCategoryList = () => {
  //   const reqbody = new FormData();
  //   reqbody.append(
  //     "main_category_id", categoryId
  //   )
  //   axios
  //     .post(
  //       `https://storebh.bhaaraterp.com/api/multivendor-show-sub-category-list-by-id/`,{},
  //       reqbody,
  //       {
  //         headers: {
  //           Token: localStorage.getItem("Token"),
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       setSubCategoryData(response?.data?.sub_cat_list);
  //     })
  //     .catch((error) => {
  //       console.log("error page", error.response);
  //       console.log(error);
  //     });
  // };

  // useEffect(() => {
  //   subCategoryList();
  // }, [categoryId]);

  // const brandList = () => {
  //   axios
  //     .post(`https://storebh.bhaaraterp.com/api/multivendor-show-brand-list-admin/`,{}, {
  //       headers: {
  //         Token: localStorage.getItem("Token"),
  //       },
  //     })
  //     .then((response) => {
  //       setBrandData(response?.data?.brand);
  //     })
  //     .catch((error) => {
  //       console.log("", error);
  //     });
  // };
  // useEffect(() => {
  //   brandList();
  // }, []);




  const deleteFunction = (e, id) => {
    e.preventDefault();
    const trueOk = window.confirm("are you sure delete this header...!");
    trueOk &&
      axios
        .delete(
          `https://storebh.bhaaraterp.com/api/admin/customization-header/?store_id=${storeId}&customization_header_id=${id}`,
          {
            headers: {
              Token: localStorage.getItem("Token"),
            },
          }
        )
        .then((response) => {
          toast.success(response.data.message);
          headerData();
        })
        .catch((error) => {
          console.log("", error);
        });
  };

  useEffect(() => {
    console.log("clicked");
    setOptions(() => {
      if (rowData?.main_category) {
        return "category";
      } else if (rowData?.subcategory) {
        return "subCategory";
      } else if (rowData?.brand) {
        return "brand";
      }
    });
  }, [rowData]);

  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            Manage Customization Header List
          </p>
          {/* <p className="!text-black">View/Search Product Management List</p> */}
        </div>
        <div className="p-2 pt-5">
          <Button variant="outlined" color="primary" onClick={handleOpen}>
            <AddIcon />
            Add Customization Header
          </Button>
        </div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-2">
          <span className="flex  gap-3">
            <input
              class="placeholder:italic placeholder:text-slate-400 block mx-3 bg-white w-80 border border-slate-300 rounded-md py-2 px-2 pr-3 shadow-sm focus:outline-none focus:border-slate-600 focus:ring-slate-500 focus:ring-1 sm:text-sm"
              placeholder="Search for anything..."
              type="text"
              name="search"
              value={searchQuery}
              onChange={(event) => setSearchQuery(event.target.value)}
            />
          </span>
          <span>
            <div className="text-red-500 mx-3">
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
              >
                <Box
                  sx={{ ...style, width: 930 }}
                  className="rounded-2xl !border-0"
                >
                  <div
                    id="child-modal-title "
                    className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
                  >
                    {ids == null
                      ? "Add Customization Header"
                      : "Update Customization Header"}
                  </div>
                  <div className="flex justify-between w-full">
                    <div className="w-[48%]">
                      <div>Select Main Header :</div>
                      <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          className="mt-2"
                          value={
                            mainHeaderID ||
                            rowData?.main_customization_header?.id ||
                            ""
                          }
                          onChange={(e) => setMainHeaderID(e.target.value)}
                        >
                          {mainData.map((elem) => (
                            <MenuItem value={elem?.id}>{elem?.title}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <div className="mt-2">Title :</div>
                      <TextField
                        size="small"
                        value={title}
                        onChange={(event) => setTitle(event.target.value)}
                        id="outlined-basic"
                        className="!w-[100%] !mt-1"
                      />
                      <div className="mt-2">Image :</div>
                      <TextField
                        onChange={(e) => setImage(e.target.files[0])}
                        id="outlined-basic"
                        type="file"
                        size="small"
                        className="!w-[100%] !mt-1"
                      />
                    </div>
                    <div className="w-[48%]">
                      <div className="">URL :</div>
                      <TextField
                        value={url}
                        onChange={(event) => setUrl(event.target.value)}
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                      />
                      <div className="mt-2">Ordering :</div>
                      <TextField
                        value={ordering}
                        onChange={(event) => setOrdering(event.target.value)}
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                      />
                    </div>
                  </div>
                  <div className="mt-2">
                    <div>Select Header :</div>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={options}
                        onChange={(e) => setOptions(e.target.value)}
                      >
                        <FormControlLabel
                          value="category"
                          control={<Radio />}
                          label="category"
                        />
                        <FormControlLabel
                          value="subCategory"
                          control={<Radio />}
                          label="subCategory"
                        />
                        <FormControlLabel
                          value="brand"
                          control={<Radio />}
                          label="brand"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  {options === "category" ? (
                    <div className="mt-2">
                      <div>Select Category :</div>
                      <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          className="mt-2"
                          value={categoryId || rowData?.main_category?.id || ""}
                          onChange={(e) => setCategoryId(e.target.value)}
                        >
                          {categoryData.map((elem) => (
                            <MenuItem value={elem?.id}>
                              {elem?.category}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  ) : null}
                  {options === "subCategory" ? (
                    <div className="mt-2">
                      <div>Select Sub Category :</div>
                      <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          className="mt-2"
                          value={
                            subCategoryId || rowData?.subcategory?.id || ""
                          }
                          onChange={(e) => setSubCategoryId(e.target.value)}
                        >
                          {subCategoryData.map((elem) => (
                            <MenuItem value={elem?.id}>
                              {elem?.subcategory}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  ) : null}
                  {options === "brand" ? (
                    <div className="mt-2">
                      <div>Select Brand :</div>
                      <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          className="mt-2"
                          value={brandId || rowData?.brand?.id || ""}
                          onChange={(e) => setBrandId(e.target.value)}
                        >
                          {brandData.map((elem) => (
                            <MenuItem value={elem?.id}>
                              {elem?.brand_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  ) : null}

                  <Button
                    onClick={hangleCancel}
                    variant="contained"
                    color="warning"
                    className="!py-2 !mt-3"
                  >
                    CANCEL
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                    onClick={submitCategory}
                  >
                    {ids === null ? "ADD" : "UPDATE"}
                  </Button>
                </Box>
              </Modal>
            </div>
          </span>
        </div>
        <TableContainer
          component={Paper}
          // sx={{  }}
          sx={{ width: "100%", maxHeight: 440 }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {/* <TableCell className="!text-left !p-2">
                  <Checkbox className="!m-0 !text-black" />
                </TableCell> */}
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ID
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  MAIN HEADER
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  TITLE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  CATEGORY
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  SUB CATEGORY
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  BRAND
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  URL
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  IMAGE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ORDERING
                </TableCell>
                <TableCell
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              {data &&
                data?.map((row, index) => (
                  <TableRow key={row?.id} className="!text-slate-700">
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {" "}
                      {row?.main_customization_header?.title ? row?.main_customization_header?.title : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {" "}
                      {row?.title ? row?.title : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {" "}
                      {row?.main_category?.category
                        ? row?.main_category?.category
                        : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {" "}
                      {row?.subcategory?.subcategory
                        ? row?.subcategory?.subcategory
                        : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {" "}
                      {row?.brand?.brand_name ? row?.brand?.brand_name : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.url ? row?.url : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.image ? (
                        <img src={row?.image} className="h-8 mx-auto w-8" />
                      ) : (
                        "--"
                      )}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.ordering ? row?.ordering : "--"}
                    </TableCell>

                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <DeleteIcon
                        className="!text-xl !text-red-600 !cursor-pointer"
                        onClick={(e) => deleteFunction(e, row?.id)}
                      />
                      <button onClick={handleOpen}>
                        <EditIcon
                          className="!text-xl !cursor-pointer !text-green-600"
                          onClick={() => EditFunction(row)}
                        />
                      </button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <div
          className="flex justify-between bg-white w-[100%] py-3 border-t-2 border-gray-400"
          style={{ marginRight: "0px" }}
        >
          <div className="mx-3">
            Count : <span className="text-fuchsia-600">{countData}</span>
          </div>
          <div>
            <Button className="" disabled={page === 1}>
              <ArrowBackIosIcon onClick={previousData} />
            </Button>
            {currentPage}...{totalPage}
            <Button className="" disabled={totalPage === page}>
              <ArrowForwardIosIcon onClick={nextData} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewHeader;
